export default __webpack_public_path__ + "static/media/Sizzling_bliss_large_7.9e0f9136.jpg";